module.exports = __webpack_public_path__ + "static/media/bitam.ff5b4c67.png";